export default __webpack_public_path__ + "static/media/Avatar-11.ae49f5bd.svg";